import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { MenuItemRequest, SaveResponse } from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import MenuItemForm from "./MenuItemForm";

const MenuItemCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { menuService, menuItemsUrl, menuItemDetailsUrl } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "menuItemFormCreateButton" }));

  const onCancel = () => {
    navigate(menuItemsUrl());
  };

  const onSubmit = async (values: MenuItemRequest) => {
    try {
      const response: SaveResponse = await registerPromise(
        menuService.saveMenuItem(values)
      );
      queryClient.invalidateQueries("menuItems");
      navigate(menuItemDetailsUrl(response.id));
      return response;
    } catch (err: any) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <RedirectBackButton
        redirectRoute={menuItemsUrl()}
        labelKey="backToListButtonLabel"
        style={{ marginRight: "10px" }}
      />
      <Box my={2}>
        <Typography variant="h5">
          <T id="menuItemFormCreateTitle" />
        </Typography>
      </Box>
      <MenuItemForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "menuItemFormCreateButton" })}
        onCancel={onCancel}
      />
    </>
  );
};

export default MenuItemCreateForm;
